import React, { useState, useEffect } from 'react';
import { XMarkIcon, ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';
import './ProductImageViewer.css';
import { Spinner } from '../Spinner';

interface ProductImageViewerProps {
  images: string[];
  initialIndex: number;
  onClose: () => void;
}

const ProductImageViewer: React.FC<ProductImageViewerProps> = ({ images, initialIndex, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const img = new Image();
    img.src = images[currentIndex];
    img.onload = () => {
      setLoading(false);
    };
  }, [currentIndex, images]);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <div className="full-screen-modal">
      <a className="close-button" onClick={onClose}>
        <XMarkIcon className="icon" />
      </a>
      <a className="nav-button left" onClick={handlePrev}>
        <ChevronLeftIcon className="icon" />
      </a>
      {loading ? (
      
          <Spinner size='xlarge' variant='white'/>
    
      ) : (
        <img src={images[currentIndex]} alt="Full Size" className="full-screen-image" />
      )}
      <a className="nav-button right" onClick={handleNext}>
        <ChevronRightIcon className="icon" />
      </a>
    </div>
  );
};

export default ProductImageViewer;
